import { render, staticRenderFns } from "./CommonSiteNavigationSchemaComponent.vue?vue&type=template&id=30992f34"
import script from "./CommonSiteNavigationSchemaComponent.vue?vue&type=script&lang=js"
export * from "./CommonSiteNavigationSchemaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports